import CompareSvg from '@/assets/icons/features/compare.svg?react'
import GuidedSvg from '@/assets/icons/features/guided.svg?react'
import ProtectedSvg from '@/assets/icons/features/protected.svg?react'
import ResearchSvg from '@/assets/icons/features/research.svg?react'
import ReviewsSvg from '@/assets/icons/features/reviews.svg?react'
import UncoverSvg from '@/assets/icons/features/uncover.svg?react'
import afbSvg from '@/assets/icons/social/afb.svg'
import afbDarkSvg from '@/assets/icons/social/afb-dark.svg'
import innovativeImpactImg from '@/assets/icons/social/innovative-impact.png'
import innovativeImpactDarkImg from '@/assets/icons/social/innovative-impact-dark.png'
import linkedin2Svg from '@/assets/icons/social/linkedin2.svg'
import linkedin2DarkSvg from '@/assets/icons/social/linkedin2-dark.svg'
import theBlindLifeImg from '@/assets/icons/social/the-blind-life.png'
import theBlindLifeDarkImg from '@/assets/icons/social/the-blind-life-dark.png'
import x2Svg from '@/assets/icons/social/x2.svg'
import x2DarkSvg from '@/assets/icons/social/x2-dark.svg'
import youtube2Svg from '@/assets/icons/social/youtube2.svg'
import youtube2DarkSvg from '@/assets/icons/social/youtube2-dark.svg'
// import playSvg from '@/assets/icons/play.svg'
import logoBigSvg from '@/assets/images/logo-big.svg'
import acbImg from '@/assets/images/media-mentions/acb.png'
import acbDarkImg from '@/assets/images/media-mentions/acb-dark.png'
import afbImg from '@/assets/images/media-mentions/afb.png'
import afbDarkImg from '@/assets/images/media-mentions/afb-dark.png'
import beMyEyesImg from '@/assets/images/media-mentions/bemyeyes.png'
import beMyEyesDarkImg from '@/assets/images/media-mentions/bemyeyes-dark.png'
import blindlifeImg from '@/assets/images/media-mentions/blindlife.png'
import blindlifeDarkImg from '@/assets/images/media-mentions/blindlife-dark.png'
import brailleInstituteImg from '@/assets/images/media-mentions/braille-institute.png'
import brailleInstituteDarkImg from '@/assets/images/media-mentions/braille-institute-dark.png'
import doubletapImg from '@/assets/images/media-mentions/doubletap.png'
import doubletapDarkImg from '@/assets/images/media-mentions/doubletap-dark.png'
import fightingBlindnessImg from '@/assets/images/media-mentions/fighting-blindness.png'
import fightingBlindnessDarkImg from '@/assets/images/media-mentions/fighting-blindness-dark.png'
import innovativeimpactImg from '@/assets/images/media-mentions/innovativeimpact.png'
import innovativeimpactDarkImg from '@/assets/images/media-mentions/innovativeimpact-dark.png'
import nfbImg from '@/assets/images/media-mentions/nfb.png'
import nfbDarkImg from '@/assets/images/media-mentions/nfb-dark.png'
import thatRealBlindTechShowImg from '@/assets/images/media-mentions/thatrealblindtechshow.png'
import thatRealBlindTechShowDarkImg from '@/assets/images/media-mentions/thatrealblindtechshow-dark.png'
import vistaCenterImg from '@/assets/images/media-mentions/vista-center.png'
import vistaCenterDarkImg from '@/assets/images/media-mentions/vista-center-dark.png'
import kirkAdamsImg from '@/assets/images/team/kirk-adams.png'
import patrickLongImg from '@/assets/images/team/patrick-long.png'
import samSeaveyImg from '@/assets/images/team/sam-seavey.png'
// import videoThumbnailPng from '@/assets/images/mock/video-thumbnail.png'
import SkipLink from '@/components/SkipLink'
import Footer from '@/layout/Footer'
import Navbar from '@/layout/Navbar'
import HeadTags from '@/lib/head/HeadTags'
import {Theme} from '@/lib/theme/theme'
import {useCurrentTheme} from '@/lib/theme/useCurrentTheme'
import {HomeRoute} from '@/routeRegistry'
import skipTargetProps from '@/utils/a11y/skipTargetProps'
import VisuallyHidden from '@/utils/a11y/VisuallyHidden'

import style from './AboutUs.module.scss'

// const ReactPlayer = lazy(() => import('react-player'))

const FAQ = [
  {
    summary: 'What is Innosearch?',
    content: `Innosearch is an accessible, all-in-one shopping platform augmented with a cutting-edge AI-powered shopping assistant. Innosearch aggregates millions of products from top online retailers, bringing them directly to you. With this advanced generative AI, Innosearch offers personalized product recommendations, highlights the best deals, and provides comprehensive information including reviews, total prices, shipping options, and more.
    `,
  },
  {
    summary: `What is Innosearch's mission?`,
    content: `Our mission is to create an accessible e-commerce experience for everyone. We focus to deliver a seamless end-to-end shopping experience, eliminating the need to switch tabs or visit multiple webpages. We believe that with our cutting-edge generative AI, this is possible.

    We are committed to helping you find the best possible deals, including coupons, cash back offers, and discounts. Our goal is to ensure you have all the essential information you need before making any purchase, so you can shop confidently and save money.
    `,
  },
  {
    summary: 'What makes Innosearch different?',
    content: `Innosearch provides access to millions of products and deals from multiple online retailers. You can purchase all of them directly on Innosearch.

    Additionally, Innosearch is equipped with a fine-tuned AI assistant which offers personalized, conversational shopping guidance. This ensures a seamless and user-friendly shopping experience for everyone.`,
  },
  {
    summary: 'What retailers does Innosearch support?',
    content: `Innosearch supports all major retailers, including Amazon, Walmart, Best Buy, and Wayfair. And we're constantly expanding based on your feedback!`,
  },
  {
    summary: 'How does Innosearch manage payments?',
    content: `Innosearch uses Stripe to handle all payment processing. When you checkout, the system submits the order to Stripe, which processes the payment. Once the payment is successfully completed, the system creates a new order in our database with the payment details provided by Stripe.`,
  },
  {
    summary: 'How does Innosearch ensure payment security?',
    content: `Innosearch leverages Stripe's robust security features to ensure that all payments are processed securely. Stripe complies with the Payment Card Industry Data Security Standard (PCI DSS), which includes encryption of sensitive data, secure transmission, and regular security audits. Additionally, Stripe uses machine learning to detect and prevent fraud, providing an extra layer of security for all transactions.`,
  },
  {
    summary: 'Does Innosearch store my credit card information?',
    content: `No, your credit card information is handled directly by Stripe when you check out. Innosearch does not process or store your credit card information.`,
  },
  {
    summary: 'How does Innosearch process orders and handle shipping?',
    content: `Once an order is confirmed and payment is received, Innosearch will process the order with the respective retailer and arrange shipment to you. You will receive updates at each stage of their order: Awaiting Shipment, Shipped, and Delivered.`,
  },
  {
    summary: 'Do I need to link my Amazon account to Innosearch?',
    content: `No, your Amazon account is separate from Innosearch. Any purchases you make on Innosearch will not appear in your Amazon account's history.`,
  },
  {
    summary: 'How does Innosearch handle returns?',
    content: `You can request a return within 30 days of delivery. Once we receive your request, our team will contact you and guide you through the return process.`,
  },
  {
    summary: 'What should I do if they encounter issues with payment or order?',
    content: `Please contact our customer support at support@innosearch.ai for assistance.`,
  },
  {
    summary: 'Which countries is Innosearch available?',
    content: `Innosearch is now available in the US, the UK, Canada, and Australia.`,
  },
  {
    summary: `How can I start using Innosearch?`,
    content: `Head over to innosearch.ai to start shopping and meet your AI shopping assistant!`,
  },
]

const MEDIA_MENTIONS = [
  {
    label: 'Sam Seavey Influencer',
    image: {
      light: blindlifeImg,
      dark: blindlifeDarkImg,
    },
    link: 'https://www.youtube.com/watch?v=-rjL-HAwaZY',
    size: 'normal',
  },
  {
    label: 'Double Tap',
    image: {
      light: doubletapImg,
      dark: doubletapDarkImg,
    },
    link: 'https://www.youtube.com/watch?v=5HgEkuHogQc',
    size: 'normal',
  },
  {
    label: 'InnovativeImpact Monthly Webinar',
    image: {
      light: innovativeimpactImg,
      dark: innovativeimpactDarkImg,
    },
    link: 'https://drkirkadams.com/about/',
    size: 'normal',
  },
  {
    label: 'Co-hosted VistaCenter Conference',
    image: {
      light: vistaCenterImg,
      dark: vistaCenterDarkImg,
    },
    link: 'https://vistacenter.org/',
    size: 'normal',
  },
  {
    label: 'Accessible Holiday Shopping Show with InnosearchAI and ACB',
    image: {
      light: acbImg,
      dark: acbDarkImg,
    },
    link: 'https://www.acb.org/home',
    size: 'normal',
  },
  {
    label: 'Braille Institute',
    image: {
      light: brailleInstituteImg,
      dark: brailleInstituteDarkImg,
    },
    link: 'https://www.brailleinstitute.org/',
    size: 'normal',
  },
  {
    label: 'Foundation Fighting Blindness',
    image: {
      light: fightingBlindnessImg,
      dark: fightingBlindnessDarkImg,
    },
    link: 'https://www.fightingblindness.org/',
    size: 'normal',
  },
  {
    label: 'American Foundation for the Blind',
    image: {
      light: afbImg,
      dark: afbDarkImg,
    },
    link: 'https://www.afb.org/',
    size: 'normal',
  },
  {
    label: 'That Real Blind Tech Show',
    image: {
      light: thatRealBlindTechShowImg,
      dark: thatRealBlindTechShowDarkImg,
    },
    link: 'https://thatrealblindtechshow.libsyn.com/episode-168-innosearchai-the-future-of-blind-online-shopping-is-here',
    size: 'large',
  },
  {
    label: 'Be My Eyes',
    image: {
      light: beMyEyesImg,
      dark: beMyEyesDarkImg,
    },
    link: 'https://www.bemyeyes.com/news/be-my-eyes-to-provide-in-app-accessible-shopping/',
    size: 'normal',
  },
  {
    label: 'National Federation of the Blind',
    image: {
      light: nfbImg,
      dark: nfbDarkImg,
    },
    link: 'https://nfb.org/about-us/press-room/innosearch-ai-and-national-federation-blind-announce-strategic-partnership',
    size: 'large',
  },
]

const TEAM = [
  {
    name: 'Patrick Long',
    position: 'Co-Founder',
    description:
      "is an innovator in assistive technology and AI, dedicated to empowering the 300 million blind and visually impaired individuals worldwide. With experience in blockchain and a background as a CPA, he focuses on leveraging technology to drive meaningful change in people's lives.",
    image: patrickLongImg,
    links: [
      {
        icon: linkedin2Svg,
        iconDark: linkedin2DarkSvg,
        link: 'https://www.linkedin.com/in/patrick-long-cpa/',
        label: "Patrick Long's LinkedIn",
      },
      {
        icon: x2Svg,
        iconDark: x2DarkSvg,
        link: 'https://x.com/patricktlong',
        label: "Patrick Long's X",
      },
    ],
  },
  {
    name: 'Dr. Kirk Adams',
    position: 'Advisor',
    description:
      'Dr. Kirk Adams is an expert in disability employment and inclusion, dedicated to helping blind and visually impaired individuals live their fullest lives. With over 20 years of experience leading nonprofits like the Seattle Lighthouse for the Blind and the American Foundation for the Blind, he believes that new technologies like AI and LLMs hold great promise for helping blind and visually impaired individuals lead more fulfilling lives.',
    image: kirkAdamsImg,
    links: [
      {
        icon: linkedin2Svg,
        iconDark: linkedin2DarkSvg,
        link: 'https://www.linkedin.com/in/kirkadamsphd/',
        label: "Dr. Kirk Adams's LinkedIn",
      },
      {
        icon: afbSvg,
        iconDark: afbDarkSvg,
        link: 'https://www.afb.org/kirk-adams',
        label: "Dr. Kirk Adams's Profile on American Foundation for the Blind",
      },
      {
        icon: innovativeImpactImg,
        iconDark: innovativeImpactDarkImg,
        link: 'https://drkirkadams.com/about/',
        label: "Innovative Impact's Website",
      },
    ],
  },
  {
    name: 'Sam Seavey',
    position: 'Brand Ambassador',
    description:
      'Sam Seavey, the visionary behind The Blind Life YouTube channel, has established himself as a trailblazer in assistive technology, recognized by the Foundation Fighting Blindness as one of the best online resources. With over 60,000 subscribers and more than 900 informative videos, he shares invaluable insights on daily living, reviews cutting-edge assistive devices, and conducts enlightening interviews with key influencers in the visually impaired community.',
    image: samSeaveyImg,
    links: [
      {
        icon: youtube2Svg,
        iconDark: youtube2DarkSvg,
        link: 'https://www.youtube.com/c/theblindlife',
        label: 'The Blind Life YouTube Channel',
      },
      {
        icon: theBlindLifeImg,
        iconDark: theBlindLifeDarkImg,
        link: 'https://www.youtube.com/watch?v=-rjL-HAwaZY',
        label: 'The Blind Life Website',
      },
    ],
  },
]

export default function AboutUs() {
  const [currentTheme] = useCurrentTheme()

  return (
    <div>
      <HeadTags title='About Us' />
      <SkipLink title='Skip to main content' to='#main-content' />
      <Navbar variant='dark' />
      <main {...skipTargetProps('main-content')} className={style.Page}>
        <div className={style.Section1}>
          <div className={style.Section1Start}>
            <h1 className={style.Heading}>Innosearch AI</h1>
            <div className={style.SubHeading}>
              We are an e-commerce platform focused on making online shopping easy and enjoyable,
              especially for those with internet access challenges like blind or low-vision users.
              Innosearch offers millions of products and deals, and our site is fully accessible,
              working seamlessly with NVDA, Apple Voiceover, and other popular screen readers.
              <br></br>
              <br></br>
              Anyone who finds current e-commerce platforms too complicated to navigate can use
              Innosearch to shop online effortlessly with just a few clicks.
            </div>
            <Link to={HomeRoute.fullPath} role='button' className={style.CtaBtn}>
              Shop now
            </Link>
          </div>
          <div className={style.Section1End}>
            <img
              className={style.Decoration}
              src={logoBigSvg}
              alt='InnoSearch'
              aria-hidden='true'
            />
          </div>
        </div>
        {/* <Suspense>
          <div className={style.Section2}>
            <div className={style.VideoWrapper}>
              <ReactPlayer
                url='https://www.youtube.com/watch?v=Fczfr4kcyYY'
                className={style.Video}
                light={
                  <img src={videoThumbnailPng} alt='Innoseach AI introduction' aria-hidden='true' />
                }
                playIcon={
                  <img
                    className={style.PlayBtn}
                    src={playSvg}
                    alt='Play'
                    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role -- its intentonal, there is no easier way to make this accessible
                    role='button'
                    tabIndex={0}
                  />
                }
                width='100%'
                height='100%'
                playsinline
                playing
                controls
              />
            </div>
          </div>
        </Suspense> */}
        <div className={style.Section3}>
          <div className={style.Section3Container}>
            <div className={style.Section3Start}>
              <div className={style.Headline} role='heading' aria-level={2}>
                Key features
              </div>
              <h3 className={style.Featured}>All-in-One Shopping Platform</h3>
              <div className={style.Description}>
                Innosearch aims to deliver a seamless end-to-end shopping experience, eliminating
                the need to search and browse in multiple tabs across retailers.
              </div>
            </div>
            <div className={style.Section3Main}>
              <div className={style.Feature}>
                <div className={style.Icon}>
                  <ResearchSvg aria-hidden />
                </div>
                <div>
                  <h3>Research Products</h3>
                  <div className={style.FeatureDescription}>
                    Easily compare products across retailers, or weigh pros and cons of similar
                    products to make informed decisions.
                  </div>
                </div>
              </div>
              <div className={style.Feature}>
                <div className={style.Icon}>
                  <CompareSvg aria-hidden />
                </div>
                <div>
                  <h3>Uncover the best deals</h3>
                  <div className={style.FeatureDescription}>
                    Never miss a doorbuster, coupon, or clearance sale again. Get notified about the
                    best prices and offers.
                  </div>
                </div>
              </div>
              <div className={style.Feature}>
                <div className={style.Icon}>
                  <UncoverSvg aria-hidden />
                </div>
                <div>
                  <h3>AI Summarized Trusted Reviews</h3>
                  <div>
                    <div className={style.FeatureDescription}>
                      See what others are saying and make confident purchases.
                    </div>
                  </div>
                </div>
              </div>
              <div className={style.Feature}>
                <div className={style.Icon}>
                  <ReviewsSvg aria-hidden />
                </div>
                <div>
                  <h3>Accessible, All in One</h3>
                  <div className={style.FeatureDescription}>
                    Never experience glitches or feel lost on an e-commerce page again. Innosearch
                    brings millions of products from top online retailers directly to you, allowing
                    you to shop the best products and deals easily.
                  </div>
                </div>
              </div>
              <div className={style.Feature}>
                <div className={style.Icon}>
                  <ProtectedSvg aria-hidden />
                </div>
                <div>
                  <h3>Shop with confidence</h3>
                  <div className={style.FeatureDescription}>
                    Rest assured, Innosearch has you covered with free shipping and returns on every
                    purchase.
                  </div>
                </div>
              </div>
              <div className={style.Feature}>
                <div className={style.Icon}>
                  <GuidedSvg aria-hidden />
                </div>
                <div>
                  <h3>Know before you buy</h3>
                  <div className={style.FeatureDescription}>
                    Innosearch equips you with expert buying guides, empowering you to make
                    well-informed decisions.
                  </div>
                </div>
              </div>
            </div>
            <div className={style.Section3End}>
              <span>Start Shopping Smarter Today!</span>
              <Link to={HomeRoute.fullPath} className={style.StartConvo}>
                Start shopping
              </Link>
            </div>
          </div>
        </div>
        <div className={style.Section5}>
          <div className={style.Section5Container}>
            <div className={style.Section5Start}>
              {/* <div className={style.Headline} role='heading' aria-level={2}>
                Key features
              </div> */}
              <h2 className={style.Featured}>
                Trusted by<VisuallyHidden>&nbsp;the accessibility community</VisuallyHidden>
              </h2>
              <div className={style.Description} aria-hidden>
                the accessibility community
              </div>
            </div>
            <div className={style.Section5MediaMentions} role='list'>
              {MEDIA_MENTIONS.map(item => {
                const image = currentTheme === Theme.Dark ? item.image.dark : item.image.light

                return (
                  <div
                    key={image}
                    className={clsx(style.ListItem, item.size === 'large')}
                    role='listitem'
                  >
                    <a href={item.link} target='_blank' rel='noopener noreferrer'>
                      <img
                        src={image}
                        alt={item.label}
                        className={style.ListItemImage}
                        loading='lazy'
                      />
                    </a>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
        <div className={style.Section6}>
          <div className={style.Section6Container}>
            <div className={style.Section6Start}>
              {/* <div className={style.Headline} role='heading' aria-level={2}>
                Key features
              </div> */}
              <h2 className={style.Featured}>Meet our team</h2>
            </div>
            <ul className={style.Section6Team}>
              {TEAM.map(item => (
                <li key={item.name} className={style.TeamMember}>
                  <img className={style.ProfileImage} src={item.image} alt={item.name} />
                  <div className={style.TeamMemberInfo}>
                    <h4 className={style.TeamMemberName}>{item.name}</h4>
                    <div className={style.TeamMemberPosition}>{item.position}</div>
                  </div>
                  <div className={style.TeamMemberDescription}>{item.description}</div>
                  <ul className={style.TeamMemberLinks}>
                    {item.links.map(link => {
                      const icon = currentTheme === Theme.Dark ? link.iconDark : link.icon

                      return (
                        <li key={link.link}>
                          <a href={link.link} target='_blank' rel='noopener noreferrer'>
                            <img src={icon} alt={link.label} loading='lazy' />
                          </a>
                        </li>
                      )
                    })}
                  </ul>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className={style.Section4}>
          <div className={style.Section4Container}>
            <h2>FAQs</h2>
            <div className={style.FAQContent}>
              {FAQ.map((item, index) => (
                <details key={index}>
                  <summary>{item.summary}</summary>
                  <div className={style.Content} role='region' aria-label={item.summary}>
                    {item.content}
                  </div>
                </details>
              ))}
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  )
}
